<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable  copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
	<div class="card-title-block">
		<span class="card-title-label" translate>commercial-documents.all-my-documents</span>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input [placeholder]="'search.placeholder' | translate" matInput type="text" spellcheck="false"
				autocomplete="off"
				[formControl]="searchTextControl" />
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');"
				tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
		<div class="grid-6 copo-container">
			<div *ngFor="let document of scroller.list" class="grid-column-one-full card-block">
				<copo-invoice [orderDisplay]="orderDisplay" [document]="document" [getUniqueOrderName]="getUniqueOrderName" (createFilter)="createFilter($event)" *ngIf="document.type === 'IN'"></copo-invoice>
				<copo-certificate [orderDisplay]="orderDisplay" [document]="document" (createFilter)="createFilter($event)" *ngIf="document.type === 'CE'"></copo-certificate>
				<copo-dispatch-advice [orderDisplay]="orderDisplay" [document]="document" [getUniqueOrderName]="getUniqueOrderName" (createFilter)="createFilter($event)" *ngIf="document.type === 'DA'"></copo-dispatch-advice>
				<copo-order-acknowledgment [orderDisplay]="orderDisplay" [document]="document" [getOrderName]="getOrderName.bind(this)" (createFilter)="createFilter($event)" *ngIf="document.type === 'OA'"></copo-order-acknowledgment>
			</div>
			<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
			<div translate class="empty-page-text grid-column-one-full"
				*ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
		</div>
</div>